<template>
  <v-card flat class="mt-4" v-if="selectedOrder">
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <v-card-title>BESTÄLLNING</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col class="subtitle">Avser</v-col>
            <v-col>
              <div>Distansutbildning lärling</div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col  class="subtitle">
              Lärling
            </v-col>
            <v-col>
              <div v-if="selectedOrder.educationExtension.education.person">
                <router-link
                    :to="'/people/' + selectedOrder.educationExtension.education.person.id"
                >{{ selectedOrder.educationExtension.education.person.firstName | filterString }} {{ selectedOrder.educationExtension.education.person.lastName }} {{ selectedOrder.educationExtension.education.person.personalNumber | maskedPersonalNumber }}</router-link>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">
              Yrke
            </v-col>
            <v-col>
              <div
                  v-if="selectedOrder.educationExtension.education.profession && selectedOrder.educationExtension.education.profession.id && selectedOrder.educationExtension.education.profession.name"
              >{{ selectedOrder.educationExtension.education.profession.name | filterString }}</div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">BYN-region</v-col>
            <v-col>
              <div v-if="selectedOrder.educationExtension.education.region && selectedOrder.educationExtension.education.region.name">{{ selectedOrder.educationExtension.education.region.name | filterString }}</div>
            </v-col>
          </v-row>
<!--          <v-row no-gutters>-->
<!--            <v-col class="subtitle">BYN-handläggare</v-col>-->
<!--            <v-col>-->
<!--              <div v-if="selectedOrder.createdById && selectedOrder.createdBy && selectedOrder.createdBy.firstName && selectedOrder.createdBy.lastName">-->
<!--                <router-link-->
<!--                    :to="'/users/' + selectedOrder.createdById"-->
<!--                >{{ selectedOrder.createdBy.firstName }} {{ selectedOrder.createdBy.lastName }}</router-link>-->
<!--              </div>-->
<!--            </v-col>-->
<!--          </v-row>-->
        </v-card-text>
      </v-col>

      <v-col class="section ma-0 pa-0" cols="12" md="6">
        <v-card-title>FÖRETAG</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col class="subtitle">Företag</v-col>
            <v-col>
              <div v-if="selectedOrder.companyId && selectedOrder.company && selectedOrder.company.name">
                <router-link
                    :to="'/companies/' + selectedOrder.companyId"
                >{{ selectedOrder.company.name }}</router-link>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col  class="subtitle">
              Org. nr
            </v-col>
            <v-col>
              <div
                  v-if="selectedOrder.companyId && selectedOrder.company && selectedOrder.company.organizationalNumber"
              >{{ selectedOrder.company.organizationalNumber | orgNo }}</div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">
              Adress
            </v-col>
            <v-col>
              <template v-if="selectedOrder.companyId">
                <div>{{selectedOrder.company.postalAddress1}}</div>
                <div v-if="selectedOrder.company.postalAddress2">{{selectedOrder.company.postalAddress2}}</div>
                <div>{{getZipFormat(this.selectedOrder.company.postalZip)}}, {{selectedOrder.company.postalCity}}</div>
              </template>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col  class="subtitle">
              Telefonnummer
            </v-col>
            <v-col>
              <div v-if="selectedOrder.companyId">{{ selectedOrder.company.phone }}</div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col  class="subtitle">
              E-postadress
            </v-col>
            <v-col>
              <div v-if="selectedOrder.companyId">
                <a :href="'mailto:' + selectedOrder.company.email">{{ selectedOrder.company.email }}</a>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <v-card-title>FAKTURAUPPGIFTER</v-card-title>
        <v-card-text>
<!--          <v-row no-gutters>-->
<!--            <v-col  class="subtitle">-->
<!--              Faktureringsadress-->
<!--            </v-col>-->
<!--            <v-col>-->
<!--              <div>{{ orderAddress }}</div>-->
<!--            </v-col>-->
<!--          </v-row>-->
          <v-row no-gutters>
            <v-col  class="subtitle">
              Kontaktperson
            </v-col>
            <v-col>
              <div v-if="selectedOrder.contactPerson">
                <router-link
                    :to="'/people/' + selectedOrder.contactPersonId"
                >{{ selectedOrder.contactPerson.firstName }} {{ selectedOrder.contactPerson.lastName }}</router-link>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col  class="subtitle">
              Förlängning grundutbildning
            </v-col>
            <v-col>
              <div v-if="selectedOrder.educationExtension">
                {{ selectedOrder.educationExtension.distanceEducationProviderExtension.months }} månader
              </div>
            </v-col>
          </v-row>
<!--          <v-row no-gutters>-->
<!--            <v-col  class="subtitle">-->
<!--              E-post för fakturering-->
<!--            </v-col>-->
<!--            <v-col>-->
<!--              <div v-if="selectedOrder.options && selectedOrder.options.invoiceEmail">-->
<!--                <a-->
<!--                    :href="'mailto:' + selectedOrder.options.invoiceEmail"-->
<!--                >{{ selectedOrder.options.invoiceEmail }}</a>-->
<!--              </div>-->
<!--              <div v-else>-</div>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--          <v-row no-gutters>-->
<!--            <v-col  class="subtitle">-->
<!--              Önskad faktureringsmetod-->
<!--            </v-col>-->
<!--            <v-col>-->
<!--              <div>-->
<!--                {{ getDeliveryMethodName(selectedOrder.options) }}-->
<!--              </div>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--          <v-row no-gutters>-->
<!--            <v-col class="subtitle">-->
<!--              Kostnadsställe-->
<!--            </v-col>-->
<!--            <v-col>-->
<!--              <div-->
<!--                  v-if="selectedOrder.options && selectedOrder.options.costCentre"-->
<!--              >{{ selectedOrder.options.costCentre}}</div>-->
<!--              <div v-else>-</div>-->
<!--            </v-col>-->
<!--          </v-row>-->
        </v-card-text>
      </v-col>
      <v-col></v-col>
    </v-row>
<!--    <v-dialog v-model="dialog" max-width="600px">-->
<!--      <OrderAddOrderRow-->
<!--          @close="dialog = false"-->
<!--          :item="editedItem"-->
<!--          :distanceOrderRows="selectedOrder.distanceOrderRows"-->
<!--          :id="selectedOrder.id"-->
<!--          :professionId="selectedOrder.professionId"-->
<!--          @save="save"-->
<!--      ></OrderAddOrderRow>-->
<!--    </v-dialog>-->

<!--    <v-card-actions >-->
<!--      <v-btn color="secondary" @click="editOrderRow">-->
<!--        <v-icon class="ml-1">$sl-add</v-icon>Lägg till rad-->
<!--      </v-btn>-->
<!--    </v-card-actions >-->

    <v-card-text>
      <v-card-title class="invoice-amount my-10">
        <div>Fakturabelopp (exkl. moms)</div>
        <div>{{ invoiceAmount | currency | withCurrencyCode }}</div>
      </v-card-title>
    </v-card-text>
<!--    <v-card-actions class="mb-6">-->
<!--      <v-row>-->
<!--        <v-col class="pt-2">-->
<!--          <v-btn disabled @click="sendToEconomy" class="mr-4">-->
<!--            <v-icon>$sl-upload</v-icon>Skicka till ekonomisystem-->
<!--          </v-btn>-->
<!--          <v-btn color="secondary" disabled @click="sendCopy" class="mr-4">-->
<!--            <v-icon>$sl-email</v-icon>Skicka kopia med e-post-->
<!--          </v-btn>-->

<!--          <v-btn color="secondary" class="mr-4 icon" @click="doDownload" :disabled="!userAdminAndKanslistCan()">-->
<!--            <v-icon>$sl-download</v-icon>Ladda ned fil-->
<!--          </v-btn>-->
<!--          <v-btn color="secondary" @click="doPrint">-->
<!--            <v-icon>$sl-printer</v-icon>Skriv ut-->
<!--          </v-btn>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--    </v-card-actions>-->
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import AddressBox from '@/components/AddressBox'
import OrderAddOrderRow from '@/components/order/OrderAddOrderRow'

import pick from 'lodash/pick'
import find from 'lodash/find'
import {RulesMixin, UserRules} from '@/components/mixins'
import API from '@/services/api.js'
import findIndex from 'lodash/findIndex'
import {DownloadsMixin} from '@/components/mixins'
import {PrintsMixin} from '@/components/mixins'

// @group Order
// InvoiceDetail component
export default {
  name: 'ExtensionOrderDetails',

  mixins: [RulesMixin, DownloadsMixin, PrintsMixin, UserRules],

  components: {
    AddressBox,
    OrderAddOrderRow
  },

  props: {
    selectedOrder: {
      type: Object,
    }
  },

  data: () => ({
    sendPaper: false,
    ordertable: [],
    dialog: false,
    editIndex: -1,
    editedItem: {},
    newItem: {
      id: 0,
      item: {
        id: '',
        name: ''
      },
      vat: 25,
      netto: 0,
      price: 0
    },
    invoiceAmount: 0,
    orderAddress: '-'
  }),

  watch: {
    selectedOrder: {
      handler: function() {
        if (this.selectedOrder && this.selectedOrder.id) {
          this.init()
        }
      },
      deep: true
    }
  },

  created() {
    this.init()
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),
  },

  methods: {

    getOrderAddress() {

      if (this.selectedOrder && this.selectedOrder.company && this.selectedOrder.company.workplaces && this.selectedOrder.options && this.selectedOrder.options.invoiceWorkplaceId) {

        const wp = find(this.selectedOrder.company.workplaces, ['id',Number(this.selectedOrder.options.invoiceWorkplaceId)])
        if (wp) {
          this.orderAddress = `${wp.postalAddress1} ${wp.postalAddress2 ? wp.postalAddress2 : ''},`
          this.orderAddress += this.getZipFormat(wp.postalZip) + ` ${wp.postalCity}`
        } else {
          this.orderAddress = '-'
        }
      } else if (this.selectedOrder.options && this.selectedOrder.options.invoiceAddress) {
        this.orderAddress = `${this.selectedOrder.options.invoiceAddress.address1} ${this.selectedOrder.options.invoiceAddress.address2 ? this.selectedOrder.options.invoiceAddress.address2 : ''},`
        this.orderAddress += this.getZipFormat(this.selectedOrder.options.invoiceAddress.zip) + ` ${this.selectedOrder.options.invoiceAddress.city}`
      } else {
        this.orderAddress = '-'
      }
    },
    getZipFormat(value){
      if (!value || value==undefined) {
        return ''
      }
      value = value.replace(' ', '')
      try {
        //value = value.replace(' ', '')
        return value.substr(0, 3) + ' ' + value.substr(3, 2)
      } catch {
        return value
      }
    },
    getAmount() {
      this.invoiceAmount = this.selectedOrder?.educationExtension?.price || 0
    },

    init() {
      this.getAmount()
      this.getOrderAddress()
    },

    copyEmail(e) {
      //-TODO copy email to the clipboard
    },

    editOrderRow() {
      this.editedItem = this.newItem
      this.dialog = true
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    sendToEconomy() {
      //-TODO add API to the button click event
    },
    // @vuese
    //- Used to download distance order xml
    doDownload() {
      API.exportDistanceOrders({
        selectedOrders: [this.selectedOrder.id],
        exportType: 'xml'
      })
          .then(response => {
            const blob = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}))
            this.downloadFile('orders.xml',blob)
          })
          .catch(error => {
            console.log('There was an error:', error)
          })
    },

    sendCopy() {
      //-TODO add API
    },

    doPrint() {
      this.printOrder(this.selectedOrder)
    },

    save() {
      this.$events.fire('showInfo', 'Sparad.')
      this.dialog = false
      this.$emit('updated')
    },

    getDeliveryMethodName(options) {
      if(!(options && options.invioceDeliveryMethod)) return "-"

      switch (options.invioceDeliveryMethod) {
        case "1":
          return "E-post";
        case "2":
          return "Pappersfaktura";
        case "3":
          return "E-faktura";
        default:
          return "-";
      }
    }
  },

  filters: {
    filterString(s) {
      if (s) return s
      else return ''
    },
    maskedPersonalNumber(p) {
      if (p && p.length > 8) return p.substring(0, 8) + '-****'
      else return ''
    },
    orgNo(p) {
      if (p && p.length > 9) return p.substring(0, 6) + '-' + p.substring(6, 10)
      else return p
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
